/* eslint-disable import/no-cycle */
import axios from 'axios';
import moment from 'moment';

import {
  CustomException,
  getIdToken,
  getListItemsCount,
  isResponseValid,
  throwSAPError,
  downloadExcel,
} from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import {
  GET_ORDER_TABLE_DATA,
  SELECT_ORDER,
  SET_ORDER_TABLE_STATUS,
  GET_ORDER_DETAIL_DATA,
  SET_ORDER_DETAIL_STATUS,
} from '../helpers/types';

const invalidResponseMsgText = i18n.t('orderScreenTranslations:INVALID_RESPONSE');

export const getOrderTableData = (skip, top, enqueueSnackbar = () => {}, filterStr = '') => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner } = auth;
    dispatch({
      type: SET_ORDER_TABLE_STATUS,
      payload: { isLoading: true, failText: '' },
    });
    const idToken = await getIdToken(dispatch, getState);

    let config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `SoldToParty eq '${BusinessPartner}'`,
        $orderby: 'SalesOrder desc',
      },
    };
    if (filterStr !== '') {
      config = {
        ...config,
        params: {
          ...config.params,
          $filter: `SoldToParty eq '${BusinessPartner}' and ${filterStr}`,
        },
      };
    }
    let listCount = null;
    if (listCount === null) {
      const url = `${systemIP}/ZAE_PB2B_SRV/ZAE_I_SalesOrder_09`;
      listCount = await getListItemsCount(config, url);
    }
    if (skip === 0 || (listCount !== null && skip <= listCount)) {
      config.params = {
        ...config.params,
        $top: top,
        $skip: skip,
      };
      const MainService = axios.create({
        baseURL: `${systemIP}/ZAE_PB2B_SRV`,
      });
      const response = await MainService.get('/ZAE_I_SalesOrder_09', config).catch(throwSAPError);
      if (isResponseValid(response)) {
        const Data = response.data.d.results.map(r => ({
          ...r,
          RequestedDeliveryDate: moment(r.RequestedDeliveryDate).format('MMMM DD, YYYY'),
        }));
        Data.sort((a, b) => b.SalesOrder - a.SalesOrder);

        dispatch({
          type: GET_ORDER_TABLE_DATA,
          payload: {
            data: Data,
            listCount,
          },
        });
      } else {
        throw new CustomException(invalidResponseMsgText);
      }
    }
  } catch (error) {
    enqueueSnackbar(i18n.t('orderScreenTranslations:UNABLE_TO_LOAD_ORDERS_DATA'), {
      variant: 'error',
    });
  }
};

export const getAllOrdersData = (skip, top, enqueueSnackbar = () => {}) => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner } = auth;
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,
        $filter: `SoldToParty eq '${BusinessPartner}'`,
        $orderby: 'SalesOrder desc',
      },
    };

    config.params = {
      ...config.params,
      $skip: skip,
    };

    const MainService = axios.create({
      baseURL: `${systemIP}/ZAE_PB2B_SRV`,
    });
    const response = await MainService.get('/ZAE_I_SalesOrder_09', config).catch(throwSAPError);
    if (isResponseValid(response)) {
      const Data = response.data.d.results.map(r => ({
        OrderId: r.SalesOrder,
        Status: r.OverallSDProcessStatusDesc,
        ShipToParty: r.SalesAreaDesc,
        DeliveryDate: moment(r.RequestedDeliveryDate).format('MMMM DD, YYYY'),
      }));
      Data.sort((a, b) => b.SalesOrder - a.SalesOrder);
      downloadExcel(Data, 'AllOrders.xlsx', 'Orders');
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    dispatch({
      type: SET_ORDER_TABLE_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('orderScreenTranslations:UNABLE_TO_LOAD_ORDERS_DATA'),
      },
    });

    enqueueSnackbar(i18n.t('orderScreenTranslations:UNABLE_TO_LOAD_ORDERS_DATA'), {
      variant: 'error',
    });
  }
};

export const selectOrder = order => ({
  type: SELECT_ORDER,
  payload: order,
});

export const getOrderData = order => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { client, systemIP, BusinessPartner } = auth;
    dispatch({
      type: SET_ORDER_DETAIL_STATUS,
      payload: { isOrderDetailLoading: true },
    });
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        'sap-client': client,

        $filter: `SoldToParty eq '${BusinessPartner}' and SalesOrder eq '${order}'`,
        $expand: 'to_Item,to_OutboundDelivery',
      },
    };
    const MainService = axios.create({
      baseURL: `${systemIP}`,
    });
    const response = await MainService.get('/ZAE_PB2B_SRV/ZAE_I_SalesOrder_09', config).catch(
      throwSAPError
    );
    if (isResponseValid(response)) {
      dispatch({
        type: GET_ORDER_DETAIL_DATA,
        payload: {
          selOrderDetailData: response.data.d.results[0],
          // isOrderDetailLoading: false,
        },
      });
    } else {
      throw new CustomException(invalidResponseMsgText);
    }
  } catch (error) {
    dispatch({
      type: SET_ORDER_DETAIL_STATUS,
      payload: { isOrderDetailLoading: false },
    });
  }
};
